import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

import { ClientConfigService } from './client-config.service';

@Injectable({
  providedIn: 'root'
})
export class DocumentService {

  private httpClient = inject(HttpClient);
  private clientConfigService = inject(ClientConfigService);
  

  isProtectedPdfFile(fd: FormData): Observable<any> {
    let customHeaders = new HttpHeaders();

    customHeaders.set('Content-Type', 'multipart/form-data');
    customHeaders.set('Accept', 'application/json');

    if (!fd.has('brokerId')) {
      fd.append('brokerId', this.clientConfigService.getBrokerId());
    }

    return this.httpClient.post(
      `${environment.onBoardingDocuments.address}/api/IsPdfFileProtected?code=${environment.onBoardingDocuments.code}`,
      fd
    );
  }

  uploadDocuments(fd: FormData): Observable<any> {
    let customHeaders = new HttpHeaders();

    customHeaders.set('Content-Type', 'multipart/form-data');
    customHeaders.set('Accept', 'application/json');

    if (!fd.has('brokerId')) {
      fd.append('brokerId', this.clientConfigService.getBrokerId());
    }

    return this.httpClient.post('http://localhost:5129/document/upload', fd, {
      headers: customHeaders,
      reportProgress: true,
      observe: 'events',
    });

    // .pipe(
    //   retryWhen((errors) => errors.pipe(delay(1000), take(5))),
    //   first((v) => true),
    //   catchError((error) => {
    //     // console.log('triggering the error after the last unsuccessful retry');
    //     return throwError(error);
    //   })
    // );
  }

}
